import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AmmDataLabelValue } from '../../components.global';
import {
  MODULE_SERVICE_NAME,
  PolarJServerModelContextPath,
} from '../constants';
import { PolarJService } from './polarj.service';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private _polarjService: PolarJService = inject(PolarJService);
  searchCategoryLabels(searchKey: string): Observable<Array<string>> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.CATALOG,
      modelName: PolarJServerModelContextPath.AM_CATEGORYS,
      requestMappingString: 'labels/' + searchKey,
      listData: true,
    });
  }

  getAllCategories(): Observable<Array<string>> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.CATALOG,
      modelName: PolarJServerModelContextPath.AM_CATEGORYS,
      requestMappingString: 'labels/ALL',
      listData: true,
    });
  }
  getAllCancelReason(): Observable<AmmDataLabelValue[]> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.MERCHANT,
      modelName: PolarJServerModelContextPath.SELECTION_DATAS,
      requestMappingString: 'list/AmOrderCancelReason',
      listData: true,
    });
  }
}
